/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ApiResult, PassthroughConfigDto } from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    PassthroughConfigDtoFromJSON,
    PassthroughConfigDtoToJSON,
} from "../models/index";

export interface PassthroughConfigDetailRequest {
    passthroughConfigId: number;
    passthroughConfigSlug?: string;
}

export interface PassthroughConfigInsertRequest {
    body?: PassthroughConfigDto;
}

export interface PassthroughConfigUpdateRequest {
    passthroughConfigId: number;
    body?: PassthroughConfigDto;
}

export interface PassthroughConfigsListRequest {
    enabled?: boolean;
}

/**
 *
 */
export class PassthroughConfigHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * PassthroughConfig details by ID or slug. Requires Permission.system_passthrough_manage or Permission.system_device_provisioning.
     */
    async passthroughConfigDetailRaw(
        requestParameters: PassthroughConfigDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<PassthroughConfigDto>> {
        if (requestParameters["passthroughConfigId"] == null) {
            throw new runtime.RequiredError(
                "passthroughConfigId",
                'Required parameter "passthroughConfigId" was null or undefined when calling passthroughConfigDetail().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["passthroughConfigSlug"] != null) {
            queryParameters["passthroughConfigSlug"] =
                requestParameters["passthroughConfigSlug"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/passthrough-configs/{passthroughConfigId}`.replace(
                    `{${"passthroughConfigId"}}`,
                    encodeURIComponent(
                        String(requestParameters["passthroughConfigId"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            PassthroughConfigDtoFromJSON(jsonValue),
        );
    }

    /**
     * PassthroughConfig details by ID or slug. Requires Permission.system_passthrough_manage or Permission.system_device_provisioning.
     */
    async passthroughConfigDetail(
        requestParameters: PassthroughConfigDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<PassthroughConfigDto> {
        const response = await this.passthroughConfigDetailRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Insert passthrough config. Requires Permission.system_passthrough_manage
     */
    async passthroughConfigInsertRaw(
        requestParameters: PassthroughConfigInsertRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/passthrough-configs`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: PassthroughConfigDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Insert passthrough config. Requires Permission.system_passthrough_manage
     */
    async passthroughConfigInsert(
        requestParameters: PassthroughConfigInsertRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.passthroughConfigInsertRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update passthrough config. Requires Permission.system_passthrough_manage
     */
    async passthroughConfigUpdateRaw(
        requestParameters: PassthroughConfigUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["passthroughConfigId"] == null) {
            throw new runtime.RequiredError(
                "passthroughConfigId",
                'Required parameter "passthroughConfigId" was null or undefined when calling passthroughConfigUpdate().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/passthrough-configs/{passthroughConfigId}`.replace(
                    `{${"passthroughConfigId"}}`,
                    encodeURIComponent(
                        String(requestParameters["passthroughConfigId"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: PassthroughConfigDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update passthrough config. Requires Permission.system_passthrough_manage
     */
    async passthroughConfigUpdate(
        requestParameters: PassthroughConfigUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.passthroughConfigUpdateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * List PassthroughConfigs. Requires Permission.system_passthrough_manage or Permission.system_device_provisioning.
     */
    async passthroughConfigsListRaw(
        requestParameters: PassthroughConfigsListRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<PassthroughConfigDto>>> {
        const queryParameters: any = {};

        if (requestParameters["enabled"] != null) {
            queryParameters["enabled"] = requestParameters["enabled"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/passthrough-configs`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(PassthroughConfigDtoFromJSON),
        );
    }

    /**
     * List PassthroughConfigs. Requires Permission.system_passthrough_manage or Permission.system_device_provisioning.
     */
    async passthroughConfigsList(
        requestParameters: PassthroughConfigsListRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<PassthroughConfigDto>> {
        const response = await this.passthroughConfigsListRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
